import React from "react";

function Alert() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96994 11.5769C6.96994 7.39228 10.5651 4 14.9999 4C19.4348 4 23.0299 7.39228 23.0299 11.5769V17.7222L24.8052 20.6392C25.2512 21.372 25.0187 22.3276 24.2859 22.7736C24.0426 22.9217 23.7632 23 23.4784 23H6.52151C5.66368 23 4.96826 22.3046 4.96826 21.4468C4.96826 21.1619 5.04659 20.8826 5.19467 20.6392L6.96994 17.7222V11.5769Z"
        stroke="black"
        strokeWidth="1.635"
      />
      <path
        d="M13 24C13 25.1046 13.8954 26 15 26C16.1046 26 17 25.1046 17 24"
        stroke="#0B0D0F"
        strokeWidth="1.635"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Alert;
